import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const DL_RESULTS_DEFAULTS = {
  enabled: true,
  alert_text: 'Działaj Lokalnie 2026 — wyniki naboru już dostępne! Sprawdź listę rankingową',
  badge_text: 'DL 2026 — wyniki ogłoszone',
  card_title: 'DL 2026 — wyniki ogłoszone',
  card_text: 'Lista rankingowa lokalnego konkursu grantowego jest już dostępna.',
  url: 'https://preview--action-seed-platform.lovable.app/aktualnosci/wyniki-sa-oto-lista-rankingowa-lokalnego-konkursu-grantowego-dzialaj-lokalnie-20',
  file_url: '/__l5e/assets-v1/572aa7c4-cd1f-4fcd-a63e-a2a9e054bb20/lista-rankingowa-dl-2026.jpg',
};

export type DlResults = typeof DL_RESULTS_DEFAULTS;

const KEYS = [
  'dl_results.enabled',
  'dl_results.alert_text',
  'dl_results.badge_text',
  'dl_results.card_title',
  'dl_results.card_text',
  'dl_results.url',
  'dl_results.file_url',
] as const;

export function useDlResults(): DlResults {
  const { data } = useQuery({
    queryKey: ['settings', 'dl_results'],
    queryFn: async () => {
      const { data } = await supabase.from('settings').select('key,value').in('key', KEYS as unknown as string[]);
      const map = Object.fromEntries((data || []).map((r: any) => [r.key, r.value]));
      const val = (k: string, d: string) => (map[k] != null && String(map[k]).length > 0 ? String(map[k]) : d);
      return {
        enabled: map['dl_results.enabled'] == null ? DL_RESULTS_DEFAULTS.enabled : map['dl_results.enabled'] === 'true',
        alert_text: val('dl_results.alert_text', DL_RESULTS_DEFAULTS.alert_text),
        badge_text: val('dl_results.badge_text', DL_RESULTS_DEFAULTS.badge_text),
        card_title: val('dl_results.card_title', DL_RESULTS_DEFAULTS.card_title),
        card_text: val('dl_results.card_text', DL_RESULTS_DEFAULTS.card_text),
        url: val('dl_results.url', DL_RESULTS_DEFAULTS.url),
        file_url: val('dl_results.file_url', DL_RESULTS_DEFAULTS.file_url),
      } as DlResults;
    },
    staleTime: 5 * 60 * 1000,
  });
  return data ?? DL_RESULTS_DEFAULTS;
}

